// Kalender-Legende (Zahlungsstatus-Farben) — extrahiert aus AppointmentsPage.js.
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

export const CalendarLegend = ({ paymentColors }) => (
  <Card className="mt-4">
    <CardContent className="p-4">
      <div className="flex items-center gap-6 text-sm flex-wrap">
        <div className="font-semibold text-gray-700">Legende:</div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded" style={{ backgroundColor: paymentColors.paid }}></div>
          <span>Ausgecheckt</span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="w-4 h-4 rounded"
            style={{
              backgroundColor: (() => {
                const color = paymentColors.paid;
                const r = parseInt(color.slice(1, 3), 16);
                const g = parseInt(color.slice(3, 5), 16);
                const b = parseInt(color.slice(5, 7), 16);
                return `rgba(${r}, ${g}, ${b}, 0.7)`;
              })()
            }}
          ></div>
          <span>Abgerechnet (Rechnung erstellt)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded" style={{ backgroundColor: paymentColors.overdue }}></div>
          <span>Vergangenheit</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded" style={{ backgroundColor: paymentColors.pending }}></div>
          <span>Service-Farbe (zukünftig)</span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="w-4 h-4 rounded border border-amber-300"
            style={{
              backgroundImage:
                'repeating-linear-gradient(135deg, rgba(245,158,11,0.35) 0px, rgba(245,158,11,0.35) 4px, transparent 4px, transparent 8px)',
            }}
          ></div>
          <span>🔒 Nur Admin/Trainer buchbar</span>
        </div>
        <div className="ml-auto text-xs text-gray-500">
          Farben einstellbar: Services → Kalender-Farbe | Einstellungen → Farben
        </div>
      </div>
    </CardContent>
  </Card>
);
